import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APIService } from 'src/app/shared/service/api.service';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';

@Component({
  selector: 'app-curso',
  templateUrl: './curso.component.html',
  styleUrls: ['./curso.component.scss'],
})
export class CursoComponent implements OnInit {
  curso: any;
  eixo: any;
  amostra: number;
  displayAll = false;
  ocupacoesCbo: string;
  legislacoes: any[];
  perfilProfissional: string;
  mudaramNome: any;
  infraestruturaMinima: any;
  itinerarios: any;
  campoAtuacao: any;
  totalInstituicoes: number;
  mensagens: string;
  areasTecnologicas: any[];
  linkSite: string;
  error: any;
  servicoIndisponivel = 'O serviço de busca de instituições ofertantes encontra-se indisponível no momento. Por favor, tente novamente mais tarde.';

  constructor(
    private route: ActivatedRoute,
    private api: APIService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    const {
      curso,
      curso: {
        eixo,
        ocupacoesCbo,
        cursoLegislacaoCncts,
        perfilProfissional,
        infraestruturaMinima,
        cursosMudaramNomeCncts,
        itinerarios,
        campoAtuacao,
        areasTecnologicas,
        cursoError,
      },
    } = this.route.snapshot.data;

    this.error = cursoError !== undefined ? true : false;

    if (!this.error) {
      this.eixo = eixo;
      this.curso = curso;
      this.ocupacoesCbo = ocupacoesCbo.length > 0 ? ocupacoesCbo : null;
      this.legislacoes = cursoLegislacaoCncts.length > 0 ? cursoLegislacaoCncts : null;
      this.perfilProfissional = perfilProfissional;
      this.mudaramNome = cursosMudaramNomeCncts.length > 0 ? cursosMudaramNomeCncts : null;
      this.infraestruturaMinima = infraestruturaMinima;
      this.itinerarios = itinerarios;
      this.campoAtuacao = campoAtuacao;
      this.areasTecnologicas = areasTecnologicas;
      this.linkSite = window.location.pathname;
      this.getQuantidadeInstituicoesPorCurso(curso.nome)
        .then(() => {
          this.mensagens = this.getMensagens(this.totalInstituicoes);
        })
        .catch(() => {
          if (this.error) {
            this.mensagens = this.servicoIndisponivel;
          }
        });
    }
  }

  /**
   *
   * @param totalInstituicoes recebe total de instituições.
   * @returns mensagens se há ou não instituições.
   */
  getMensagens(total: number): string {
    if (total === 1) {
      return `Foi identificada no Sistec ${total} instituição oferecendo este curso. Você pode visualizá-la`;
    } else if (total > 1) {
      return `Foram identificadas no Sistec ${total} instituições oferecendo este curso. Você pode visualizá-las`;
    } else {
      return `Não foram encontradas instituições oferecendo este curso.`;
    }
  }

  /**
   *
   * @param curso a ser pesquisado.
   * @returns o número de instituições ou o erro de serviço indisponível.
   */
  getQuantidadeInstituicoesPorCurso(curso: string): Promise<void> {
    this.spinnerService.show();
    return new Promise((resolve, reject) => {
      this.api.getQuantidadeInstituicoesPorNomeCurso(curso)
        .subscribe((qtdInstituicoes: any) => {
          this.totalInstituicoes = qtdInstituicoes;
          this.spinnerService.hide();
          resolve();
        }, (error) => {
          this.spinnerService.hide();
          this.error = true;
          reject(error);
        });
    });
  }
}
